import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ArrowLeft, CheckCircle2 } from "lucide-react";

import { ParceirosHeader } from "@/components/parceiros/ParceirosHeader";
import { ParceirosFooter } from "@/components/parceiros/ParceirosFooter";
import { Eyebrow } from "@/components/parceiros/Eyebrow";
import { useMetaPixel } from "@/hooks/useMetaPixel";
import { trackCompleteRegistration } from "@/lib/meta-pixel";
import { CTAAnchor } from "@/components/parceiros/cta";

const ParceirosObrigado = () => {
  useMetaPixel();
  const location = useLocation();
  // Lead que marcou "não atuo no mercado" chega com esse flag — não pode
  // disparar CompleteRegistration, senão vira sinal de conversão boa pro Meta.
  const desqualificado =
    (location.state as { desqualificado?: boolean } | null)?.desqualificado ===
    true;

  useEffect(() => {
    document.title = "Candidatura enviada — Allu Invest";

    const prevBodyBg = document.body.style.backgroundColor;
    const prevBodyFont = document.body.style.fontFamily;
    document.body.style.backgroundColor = "#FAF8F5";
    document.body.style.color = "#112711";
    document.body.style.fontFamily =
      '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif';

    if (!desqualificado) {
      trackCompleteRegistration({
        content_name: "Programa de Parceiros Allu Invest",
        content_category: "parceiros",
      });
    }

    return () => {
      document.body.style.backgroundColor = prevBodyBg;
      document.body.style.color = "";
      document.body.style.fontFamily = prevBodyFont;
    };
  }, [desqualificado]);

  return (
    <div
      className="min-h-screen bg-[#FAF8F5] text-[#323F4F] flex flex-col"
      style={{
        fontFamily:
          '"Plus Jakarta Sans", Inter, system-ui, -apple-system, sans-serif',
      }}
    >
      <ParceirosHeader />

      <main className="flex-1 flex items-center">
        <div className="container-narrow py-20 sm:py-28 w-full">
          <div className="text-center">
            <span className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-8 bg-[#D1F8E2]">
              <CheckCircle2 className="w-8 h-8 text-[#112711]" />
            </span>

            <div className="flex justify-center mb-4">
              <Eyebrow>Candidatura recebida</Eyebrow>
            </div>

            <h1
              className="font-bold text-[#323F4F] text-4xl sm:text-5xl md:text-6xl max-w-3xl mx-auto leading-[1.05] tracking-tight mt-6"
              style={{
                fontFamily:
                  "'Plus Jakarta Sans', Inter, system-ui, sans-serif",
                letterSpacing: "-0.02em",
              }}
            >
              Recebemos sua candidatura.
            </h1>

            <p className="text-base sm:text-lg text-zinc-600 mt-6 max-w-2xl mx-auto leading-relaxed">
              Nosso time de parcerias vai analisar seu perfil em até{" "}
              <span className="text-[#323F4F] font-semibold">1 dia útil</span>.
              Caso haja alinhamento, entramos em contato pelo telefone que você
              cadastrou para agendar uma conversa inicial.
            </p>

            <div className="mt-10 sm:mt-12 flex flex-col sm:flex-row items-center justify-center gap-3">
              <CTAAnchor href="/parceiros" variant="outline" size="lg">
                <ArrowLeft className="w-4 h-4" />
                Voltar para a página
              </CTAAnchor>
            </div>

            <p className="mt-12 text-xs text-zinc-500">
              Dúvidas? Entre em contato pelo e-mail{" "}
              <a
                href="mailto:parceiros@allucapital.com.br"
                className="text-[#112711] underline underline-offset-4 hover:text-[#2E694D]"
              >
                parceiros@allucapital.com.br
              </a>
              .
            </p>
          </div>
        </div>
      </main>

      <ParceirosFooter />
    </div>
  );
};

export default ParceirosObrigado;
